exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.orezo-file-input  li.deleted {\n    background: repeating-linear-gradient(135deg, #bebebe, #bebebe 5px, #ffffff 5px, #ffffff 20px);\n}\n.orezo-file-input .file-uploads {\n    display: block;\n    width: 100%;\n}\n.orezo-file-input .file-uploads * {\n    cursor: pointer;\n}\n.orezo-file-input .drag-active {\n    outline: 2px solid #0c5460;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6504eb46","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/UploadFile.vue
// module id = 537
// module chunks = 0